<template>
  <v-row>
    <v-col cols="12">
      <v-card>
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium" v-if="revenueBeta">Reglas de envío</v-toolbar-title>
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium" v-else>
            <v-row align="center" justify="start" no-gutters>
              <router-link class="subtitle-1 routerLink font-weight-medium" :to="{name: 'Receivables'}">Cuentas por cobrar</router-link>
              <v-icon class="mx-1 pt-1" color="secondary">mdi-chevron-right</v-icon>
              <span class="subtitle-1 font-weight-medium d-inline-block text-truncate">Recordatorios de pago</span>
            </v-row>
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items v-if="editableRules.length">
            <v-row align="center" justify="center" class="mr-1">
              <span class="mr-4 d-block body-2 text--primary">Activar los recordatorios automáticos</span>
              <v-switch v-model="sendPaymentsReminders" @change="updateAccount" :disabled="!editableRules.length" class="py-0 my-0" :width="32" :height="18" hide-details />
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="py-8 background card-dots overflow-y-auto" style="height: calc(100vh - 170px)">
          <v-row align="center" justify="center" v-if="$store.state.reminders.retrieveLoader">
            <v-col cols="12" lg="7" md="9">
              <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line" />
            </v-col>
          </v-row>
          <v-row class="v-card-timeline" align="center" justify="center" v-else>
            <v-col cols="12" lg="7" md="9" v-for="(d, i) in editableRules.filter(e => e.scheme === 'B')" :key="`${i}-before-due-rules`">
              <v-card :class="{ 'indigo lighten-5': activeReminder === d.id }" @click="newReminder=d, dialogNewReminder=true" :ref="`${d.id}-rule`" :ripple="false">
                <v-toolbar color="transparent" flat height="55">
                  <v-list-item-avatar size="32" color="background"><v-icon color="primary" size="18">mdi-email-outline</v-icon></v-list-item-avatar>
                  <v-toolbar-title class="text--secondary subtitle-2 font-weight-medium">
                    {{d.days}} día<template v-if="d.days > 1">s</template> <template v-if="d.scheme === 'B'">antes</template><template v-else>después</template> del vencimiento del pago
                  </v-toolbar-title>
                  <v-spacer />
                  <v-toolbar-items>
                    <v-row align="center" justify="center" class="mr-1">
                      <v-btn @click.stop="deleteRule(d)" color="red" icon :ripple="false" small><v-icon size="18">mdi-trash-can-outline</v-icon></v-btn>
                    </v-row>
                  </v-toolbar-items>
                </v-toolbar>
                <v-divider />
                <v-card-text>
                  <span>Asunto:</span> <span class="text--primary">{{d.template.subject}}</span>
                  <v-divider class="my-2" />
                  <span class="text--primary">{{d.template.message}}</span>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col class="text-center" cols="12" lg="7" md="9">
              <v-chip class="v-chip-timeline-element" outlined small text-color="primary"><v-icon left size="18">mdi-calendar-alert-outline</v-icon>Vencimiento del pago</v-chip>
            </v-col>
            <v-col cols="12" lg="7" md="9" v-for="(d, i) in editableRules.filter(e => e.scheme === 'A')" :key="`${i}-after-due-rules`">
              <v-card class="v-card-timeline" :class="{ 'indigo lighten-5': activeReminder === d.id }" @click="newReminder=d, dialogNewReminder=true" :ref="`${d.id}-rule`" :ripple="false">
                <v-toolbar color="transparent" flat height="55">
                  <v-list-item-avatar size="32" color="background"><v-icon color="primary" size="18">mdi-email-outline</v-icon></v-list-item-avatar>
                  <v-toolbar-title class="text--secondary subtitle-2 font-weight-medium">
                    {{d.days}} día<template v-if="d.days > 1">s</template> <template v-if="d.scheme === 'B'">antes</template><template v-else>después</template> del vencimiento del pago
                  </v-toolbar-title>
                  <v-spacer />
                  <v-toolbar-items>
                    <v-row align="center" justify="center" class="mr-1">
                      <v-btn @click.stop="deleteRule(d)" color="red" icon :ripple="false" small><v-icon size="18">mdi-trash-can-outline</v-icon></v-btn>
                    </v-row>
                  </v-toolbar-items>
                </v-toolbar>
                <v-divider />
                <v-card-text>
                  <span>Asunto:</span> <span class="text--primary">{{d.template.subject}}</span>
                  <v-divider class="my-2" />
                  <span class="text--primary">{{d.template.message}}</span>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col class="text-center" cols="12" lg="7" md="9">
              <v-btn color="primary" @click="dialogNewReminder=true" dark :disabled="editableRules.length >= 5" fab small :ripple="false"><v-icon dark size="22">mdi-plus</v-icon></v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>

    <!-- dialog reminder message -->
    <v-dialog v-model="dialogNewReminder" no-click-animation persistent scrollable width="800">
      <v-card>
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">{{dialogNewReminder.id ? 'Editar recordatorio automático' : 'Recordatorio automático'}}</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-btn class="ml-3" @click="dialogNewReminder=false, resetNewReminder()" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="px-0 py-3 background">
          <v-list class="transparent">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="mx-1 mb-2 text--secondary font-weight-medium"><v-icon class="mt-n1" color="secondary" size="20">mdi-clock-outline</v-icon> Programación del envío</v-list-item-title>
                <v-list-item-subtitle>
                  <v-row align="center">
                    <div class="mx-3" style="width:60px">
                      <v-text-field v-model="$v.newReminder.days.$model" :error="$v.newReminder.days.$error" background-color="white" dense hide-details outlined placeholder="1" required reverse single-line />
                    </div>
                    <span class="defaultGrey text--secondary py-3 px-2" style="border-radius:4px;">días</span>
                    <div class="mx-3" style="width:130px">
                      <v-select v-model="newReminder.scheme" :items="schemes" single-line :v-ripple="false"  item-text="text" item-value="value" hide-details dense height="30" outlined background-color="white" />
                    </div>
                    <span class="defaultGrey text--secondary py-3 px-2" style="border-radius:4px;">del vencimiento del pago</span>
                  </v-row>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="my-2" />
            <v-list-item>
              <v-list-item-content class="py-1">
                <v-list-item-subtitle>
                  <v-text-field prefix="Asunto" v-model.trim="$v.newReminder.template.subject.$model" :error="$v.newReminder.template.subject.$error" background-color="white" outlined required single-line dense maxlength="40" placeholder="Escribe un asunto para el email" :hide-details="$v.newReminder.template.subject.maxLength" persistent-hint hint="Escribe un máximo de 60 caracteres" />
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mx-5 my-2" />
            <v-list-item>
              <v-list-item-content class="py-1">
                <v-menu v-model="menuTokens" :close-on-content-click="false" min-width="180px" :nudge-bottom="10" offset-y transition="slide-y-transition">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn class="ml-1" v-bind="attrs" v-on="on" color="secondary" outlined :ripple="false"><v-icon left>mdi-code-json</v-icon>Insertar variable<v-icon right>mdi-menu-down</v-icon></v-btn>
                  </template>
                  <v-list class="pa-0">
                    <v-list-item class="px-5 py-1" v-for="(d, i) in tokens" @click="setToken(i); menuTokens=false" :key="i">
                      <v-list-item-title class="subtitle-2 font-weight-medium">{{d.label}}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content class="py-1">
                <v-textarea v-model.trim="$v.newReminder.template.message.$model" background-color="white" hide-details outlined placeholder="Escribe el mensaje del recordatorio" ref="message" />
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn @click="dialogNewReminder=false, resetNewReminder()" outlined color="secondary">Cancelar</v-btn>
          <template v-if="newReminder.id">
            <v-btn @click="updateRule" color="primary" :loading="$store.state.reminders.createLoader">Guardar</v-btn>
          </template>
          <template v-else>
            <v-btn @click="createRule" color="primary" :loading="$store.state.reminders.createLoader">Guardar</v-btn>
          </template>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog reminder message -->
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { numeric, required, maxLength } from 'vuelidate/lib/validators'
import { cloneDeep, sortBy } from 'lodash'

import CommonTemplates from '@/views/account/CommonTemplates'
import GenericViewMixin from '@/mixins/GenericViewMixin'
import RevenueBetaMixin from '@/mixins/RevenueBetaMixin'

export default {
  components: {
    CommonTemplates
  },
  mixins: [
    GenericViewMixin,
    RevenueBetaMixin
  ],
  data: () => ({
    activeReminder: null,
    dialogNewReminder: false,
    editableRules: [],
    menuTokens: false,
    newReminder: {
      days: null,
      template: {
        kind: 'collection',
        message: '',
        subject: ''
      },
      scheme: 'A'
    },
    sendPaymentsReminders: false,
    schemes: [
      { text: 'antes', value: 'B' },
      { text: 'después', value: 'A' }
    ],
    tokens: [
      { value: 'number', label: 'Número de factura', kind: ['invoicing', 'collection'] },
      { value: 'document.name', label: 'Tipo de factura', kind: ['invoicing', 'collection'] },
      { value: 'date', label: 'Fecha de la factura', kind: ['invoicing', 'collection'] },
      { value: 'due_date', label: 'Fecha de vencimiento del pago', kind: ['collection'] },
      { value: 'total', label: 'Monto total', kind: ['collection'] },
      { value: 'customer.name', label: 'Nombre del cliente', kind: ['invoicing', 'collection'] }
    ]
  }),
  computed: mapState({
    accountsDetail: state => state.accounts.accountsDetail,
    rulesList: state => cloneDeep(state.reminders.rulesList)
  }),
  created () {
    this.$store.dispatch('accounts/RETRIEVE', {
      resource: 'accounts',
      id: this.$store.state.auth.account.id
    })
    .then(() => {
      this.sendPaymentsReminders = this.accountsDetail.send_payments_reminders
    })

    this.$store.dispatch('reminders/LIST', {
      resource: 'reminders/rules',
      query: {
        expand: 'template'
      }
    })
    .then(() => {
      this.editableRules = this.rulesList.map(e => cloneDeep(e))

      this.sortEditableRules()
    })
  },
  methods: {
    createRule () {
      this.$v.newReminder.$touch()

      if (this.$v.newReminder.$invalid) {
        return false
      }

      this.$store.dispatch('reminders/CREATE', {
        resource: 'reminders/templates',
        payload: Object.assign({}, this.newReminder.template, { name: this.newReminder.template.subject })
      })
      .then((response) => {
        this.$store.dispatch('reminders/CREATE', {
          resource: 'reminders/rules',
          payload: Object.assign({}, this.newReminder, { template: response.data.id }),
          query: {
            expand: 'template'
          }
        })
        .then((response) => {
          // mark active reminder
          this.activeReminder = response.data.id
          setTimeout(() => {
            this.activeReminder = null
          }, 2000)

          // add object
          this.editableRules.push(response.data)

          // reset newReminder object
          this.resetNewReminder()

          // close dialog
          this.dialogNewReminder = false

          // sort
          this.sortEditableRules()
        })
        .catch((error) => {
          this.$dialog.message.error(this.parseErrors(error.response.data))
        })
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
    },
    deleteRule (rule) {
      this.$dialog.warning({
        title: 'Eliminar recordatorio automático',
        text: '<span class="d-block mb-4">Al confirmar se eliminará este recordatorio de tu organización.</span>',
        actions: [{
          color: 'red',
          text: 'Continuar',
          handle: () => {
            this.$store.dispatch('reminders/DESTROY', {
              resource: 'reminders/templates',
              id: rule.template.id
            })
            .then(() => {
              const i = this.editableRules.findIndex(e => e.id === rule.id)
              this.editableRules.splice(i, 1)

              this.$dialog.message.info('El recordatorio automático se ha eliminado.')
            })
            .catch((error) => {
              this.$dialog.message.error(this.parseErrors(error.response.data))
            })
          }
        }]
      })
    },
    resetNewReminder () {
      // reset object
      this.newReminder = {
        days: null,
        template: {
          kind: 'collection',
          message: '',
          subject: ''
        },
        scheme: 'A'
      }

      // reset validator
      this.$v.newReminder.$reset()
    },
    sortEditableRules () {
      if (this.editableRules.length) {
        const beforeExpiration = sortBy(this.editableRules.filter(e => e.scheme === 'B'), (e) => -e.days)
        const afterExpiration = sortBy(this.editableRules.filter(e => e.scheme === 'A'), (e) => e.days)

        this.editableRules = [...beforeExpiration, ...afterExpiration]
      }
    },
    setToken (i) {
      let message = this.newReminder.template.message

      const textarea = this.$refs.message.$refs.input
      const sentence = textarea.value
      const len = sentence.length

      let start = textarea.selectionStart

      if (start === undefined) {
        start = 0
      }

      this.newReminder.template.message = sentence.substr(0, start) + '{{' + this.tokens[i].value + '}}' + sentence.substr(start, len)

      this.$nextTick().then(() => {
        textarea.selectionStart = start + message.length
      })
    },
    updateAccount () {
      this.$store.dispatch('accounts/UPDATE', {
        resource: 'accounts',
        payload: {
          send_payments_reminders: this.sendPaymentsReminders
        },
        id: this.account.id
      })
      .then(() => {
        this.$dialog.message.info(`Se han ${this.sendPaymentsReminders ? 'habilitado' : 'deshabilitado'} los recordatorios automáticos de pagos`)
      })
      .catch(() => {
        this.$dialog.message.warning(`Error al ${this.sendPaymentsReminders ? 'habilitado' : 'deshabilitado'} los recordatorios automáticos de pagos`)
      })
    },
    updateRule () {
      this.$v.newReminder.$touch()

      if (this.$v.newReminder.$invalid) {
        return false
      }

      this.$store.dispatch('reminders/UPDATE', {
        resource: 'reminders/templates',
        id: this.newReminder.template.id,
        payload: {
          message: this.newReminder.template.message,
          name: this.newReminder.template.subject,
          subject: this.newReminder.template.subject
        }
      })
      .then(() => {
        this.$store.dispatch('reminders/UPDATE', {
          resource: 'reminders/rules',
          id: this.newReminder.id,
          payload: {
            days: this.newReminder.days,
            scheme: this.newReminder.scheme
          },
          query: {
            expand: 'template'
          }
        })
        .then(() => {
          // mark active reminder
          this.activeReminder = this.newReminder.id
          setTimeout(() => {
            this.activeReminder = null
          }, 2000)

          // reset newReminder object
          this.resetNewReminder()

          // close dialog
          this.dialogNewReminder = false

          // sort
          this.sortEditableRules()
        })
        .catch((error) => {
          this.$dialog.message.error(this.parseErrors(error.response.data))
        })
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
    }
  },
  validations: {
    newReminder: {
      days: {
        required,
        numeric
      },
      template: {
        subject: {
          required,
          maxLength: maxLength(60)
        },
        message: {
          required
        }
      }
    }
  }
}
</script>
<style>
.card-dots {
  background-image: url('../../assets/appBg--dots.svg');
  background-size: 54px;
  background-repeat: repeat;
}

.v-card-timeline .v-card::after {
  content: "";
  width: 1px;
  height: 25px;
  background-color: #D8E0EA;
  margin: 0 auto;
  position: absolute;
  left: 0;
  right: 0;
}

.v-chip-timeline-element {
  overflow: visible !important;
}

.v-chip-timeline-element::after {
  content: "";
  width: 1px;
  height: 25px;
  background-color: #D8E0EA;
  margin: 0 auto;
  position: absolute;
  left: 0;
  right: 0;
  bottom: -25px;
}
</style>